import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the offline service worker (production web builds only). A new version is downloaded
 * in the background and applied the next time the page is hidden while no run is in progress, so
 * an update never interrupts play. The save lives in localStorage, so the reload loses nothing.
 */
export function registerOfflineSupport(isPlaying: () => boolean): void {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;
  let updateReady = false;
  const update = registerSW({
    immediate: true,
    onNeedRefresh: () => {
      updateReady = true;
    },
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && updateReady && !isPlaying()) void update(true);
  });
}
